<template>
    <section
        class="media-blocks"
        :class="{
            'media-blocks--full-width': content.style.background.fullWidth.value,
            'media-blocks--background': !content.style.background.turnOff.value,
        }"
        :style="{...generateStylingVariables(content.style)}"
    >
        <div
            class="media-blocks__inner"
            :class="{
                'media-blocks__inner--background': !content.style.background.turnOff.value,
                'container container--only-desktop': !content.style.background.turnOff.value && !content.style.background.fullWidth.value,
            }"
        >
            <zoe-atom-text
                v-if="stringIsNotEmpty(content.text.value)"
                class="media-blocks__text"
                :item="content.text.value"
            />

            <ul
                class="media-blocks__list"
                :class="{
                    'media-blocks__list--vertical': content.verticalAlignItemsMobile.value,
                }"
            >
                <li
                    v-for="(item, index) in content.items"
                    :key="index"
                    class="media-blocks__item"
                >
                    <zoe-atom-media
                        class="media-blocks__media"
                        :item="item.media.value"
                    />

                    <zoe-atom-text
                        v-if="stringIsNotEmpty(item.text.value)"
                        class="media-blocks__text"
                        :item="item.text.value"
                    />
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
import ZoeAtomText from '@atoms/text/v1.0.0/zoe-atom-text.vue';
import ZoeAtomMedia from '@atoms/media/v1.0.0/zoe-atom-media.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';

export default {
    components: { ZoeAtomText, ZoeAtomMedia },
    mixins: [ Component ],

    methods: {
        generateStylingVariables
    },
};
</script>

<style lang="scss">
@use 'step-media-blocks';
</style>

<style lang="scss" scoped>
.media-blocks {
    --background: v-bind('content.style.background.color.value');
    --column-count-mobile: v-bind('content.columnCountMobile.value');
    --column-count-desktop: v-bind('content.columnCount.value');
}
</style>
